import { createClientMessage, createCustomMessage } from "react-chatbot-kit";

class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  sendUserResponse(message) {
    const clientMessage = createClientMessage(message);
    this.updateChatbotState(clientMessage);

    return clientMessage;
  }

  sendSuggestions(suggestions, mParser) {
    suggestions.forEach((sugg) => {
      const suggestionMessage = createCustomMessage(sugg, "custom", {
        payload: { text: sugg, mParser },
      });
      this.updateChatbotState(suggestionMessage);
    });
  }

  sendBotResponse(message) {
    const botMessage = this.createChatBotMessage(message);
    this.updateChatbotState(botMessage);
    return botMessage;
  }

  setIsTyping(isTyping) {
    if (isTyping) {
      const loadingMessage = this.sendBotResponse(<i>Thinking ...</i>);
      this.setState((prevState) => ({
        ...prevState,
        loadingMessage,
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        messages: prevState.messages.filter(
          (message) => message.id !== prevState.loadingMessage?.id
        ),
        loadingMessage: null, // Clear the loading message reference
      }));
    }
  }

  updateChatbotState(message) {
    this.setState((prevState) => {
      const messages = [...prevState.messages];

      // Ensure no duplicate messages are added
      if (!messages.find((msg) => msg.id === message.id)) {
        messages.push(message);
      }

      return { ...prevState, messages };
    });
  }
}

export default ActionProvider;
